import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/providers/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteScenery"] */ "/workspace/src/components/public/site-scenery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/SplashCursorWrapper.tsx");
